import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PublishIcon(props: IconProps) {
    return <Icon {...props} iconKey={"publish"}/>
}
